/* Market ticker — self-contained so it can render on EVERY page, not just the homepage.
   Baked snapshot paints instantly; the live worker feed swaps in when it answers. */
(function () {
  var track = document.getElementById("tickTrack");
  if (!track || track.dataset.tickerInit) return;
  track.dataset.tickerInit = "1";

  var TICKS = [
    ["PKM Phantasmal Flames BB","389.99",6.1],
    ["PKM Evolving Skies BB","2650.00",2.4],
    ["PKM Astral Radiance BB","409.99",3.5],
    ["OP-13 Carrying On His Will BB","469.99",-3.2],
    ["PKM Ascended Heroes ETB","79.99",1.9],
    ["PKM Ascended Heroes Bundle","94.99",2.8],
    ["Riftbound Vendetta Display","119.99",0.0],
    ["MKT SNAPSHOT · 08.07.26","",0]
  ];

  function render(rows) {
    var html = "";
    for (var pass = 0; pass < 2; pass++) {
      rows.forEach(function (t) {
        if (!t[1]) { html += '<span class="tick"><span class="sym">' + t[0] + "</span></span>"; return; }
        var cls = t[2] >= 0 ? "up" : "down", arrow = t[2] >= 0 ? "\u25B2" : "\u25BC";
        html += '<span class="tick"><span class="sym">' + t[0] + "</span><span>$" + t[1] +
                '</span><span class="' + cls + '">' + arrow + " " + Math.abs(t[2]).toFixed(1) + "%</span></span>";
      });
    }
    track.innerHTML = html;
  }

  render(TICKS);

  var feed = track.getAttribute("data-feed");
  if (feed) {
    /* No cache override: the worker answers with Cache-Control: max-age=3600, and
       "no-store" was throwing that away and sending every single pageview to Railway. */
    fetch(feed)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var rows = data.map(function (d) {
          if (Array.isArray(d)) return d;
          return [d.name, d.price != null ? String(d.price) : "", d.change || 0];
        });
        if (rows.length) { rows.push(["LIVE \u00B7 " + new Date().toLocaleDateString(), "", 0]); render(rows); }
      })
      .catch(function () {});
  }
})();
